import Button from "@/components/Button";

interface SlideFooterProps {
  onBack: () => void;
  onNext: () => void;
  disableContinue?: boolean;
}

const SlideFooter = ({ onBack, onNext, disableContinue }: SlideFooterProps) => {
  return (
    <div className="lc-flex lc-flex-col lc-justify-end lc-h-full lc-w-full">
      <div className="lc-flex lc-flex-row lc-justify-between">
        <Button
          text="Back"
          type="secondary"
          onClick={onBack}
          size="md"
          iconPosition="left"
        />
        <Button
          text="Continue"
          type="primary"
          onClick={onNext}
          size="md"
          iconPosition="right"
          disabled={disableContinue}
        />
      </div>
    </div>
  );
};

export default SlideFooter;
